import moment from 'moment'
import _, {
  last, keys, identity, isArray, range,
  isString, isObject, isFunction, has
} from 'lodash'
import Chance from 'chance'

import removeDiacritics from './diacritics'

export { top, topBy } from "./tools/topBy.js"

const chance = new Chance()

export const minutes = m => m * 60 * 1000
export const seconds = s => s * 1000

export function timestamp() {
  return (new Date()).toISOString()
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

/** Date parsing **/

export function str2date(s) {
  const ss = s.split(/[\/-]/).map(x => parseInt(x))
  return new Date(ss[0], ss[1] - 1, ss[2])
}

export const date2str = (m = null, sep = "/") => (
  (moment(m) || moment()).format(sep ? `YYYY${sep}MM${sep}DD` : "YYYY/MM/DD")
)
export const moment2str = (m, s) => date2str(m || null, s || "/")

export const time2str = d => moment(d).format("YYYY/MM/DD HH:mm:ss")

// important! use everywhere instead of moment(shittyString)
// TODO this was memoized, but it failed miserably. investigate.
export const str2moment = s => moment(s, "YYYY/MM/DD HH:mm")

export const getToday = () => moment().startOf("day")

/* urls and shit */

// adapted from https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
// eslint-disable-next-line no-useless-escape
const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@;:%_\+.~#?&//=]*)/g

// searches for urls; shortens them if very long
export function linkifyMarkdown(s) {
  return s.replace(urlRegex, match => (
    match.length > 30
      ? `[${match.substring(0, 28)}…](${match}) `
      : `[${match}](${match}) `
  ))
}

/* */

// #TODO do we need this? can we not use lodash.size
export function size(obj) {
  return Object.keys(obj).length
}

export function getQueryString(obj) {
  return Object.keys(obj).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(obj[k])}`).join('&');
}

export function _cleanString(s) {
  return (removeDiacritics(s) || s).replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
}

export const datesRange = (start, length) => (range(0, length).map(n => moment(start).add(n, "days")))

// a = [0,3,4,1,5,2,3,1,5]
// chunkFromFirstBy(a, 5, x => x)  ->  [ [ 0, 3 ], [ 4, 1 ], [ 5 ], [ 2, 3 ], [ 1 ], [ 5 ] ]
// chunkFromFirstBy(a, 10, x => 2*x)  ->  [ [ 0, 3 ], [ 4, 1 ], [ 5 ], [ 2, 3 ], [ 1 ], [ 5 ] ]
export function chunkFromFirstBy(array, chunkSize, weight = (x => x)) {
  const chunks = []
  chunks.push([])
  let ci = 0

  let i = 0
  let lastChunkSize = 0
  for (i = 0; i < array.length; i++) {
    if (lastChunkSize != 0 && weight(array[i]) + lastChunkSize > chunkSize) {
      lastChunkSize = 0
      chunks.push([])
      ci++
    }
    lastChunkSize += weight(array[i])
    chunks[ci].push(array[i])
  }

  return chunks
}

// simple memoization
export const cleanString = (() => {
  const b = [{}, {}];  // buffers
  const c = [0, 0];    // buffer size coutners
  let bi = 0;          // buffer index (where to write)
  const max = 10000;    // max buffer size

  const toggle = () => {
    bi = (bi + 1) % 2;
    b[bi] = {};
    c[bi] = 0;
  }

  return s => {
    if (has(b[0], s)) { return b[0][s]; }
    if (has(b[1], s)) { return b[1][s]; }

    const result = _cleanString(s);
    b[bi][s] = result;
    if (++c[bi] >= max) toggle();
    return result;
  }
})()

// (a: Array<any>, f: (x: any, y: any) => number
export function sorted(a, f) {
  return a.slice().sort(f)
}

export function sortByLocale(a) { return a.sort((x, y) => x.localeCompare(y)) }

/**
 * maxChars
 * @param {*} input
 * @param {*} n
 */
export function maxChars(input: any, n: number): string {
  const s = (isString(input) ? input : JSON.stringify(input)).substr(0, n)
  return s + (isObject(input) ? ' ... }' : '...')
}

// i use my own minBy and maxBy because no other has the same signature for the iteratee

export function minBy(a: Array<any>, f = (x) => x): any {
  if (!a) return undefined
  let min: number = Infinity
  let minX: any = null
  a.forEach((x: any, i: number) => {
    const fx = f(x, i);
    if (fx < min) {
      min = fx;
      minX = x;
    }
  })
  return minX
}

export function maxBy(a, f = identity) {
  if (!a) return undefined
  let max = -Infinity
  let maxX = null
  a.forEach((x, i) => {
    const fx = f(x, i);
    if (fx > max) {
      max = fx;
      maxX = x;
    }
  })
  return maxX
}

export function l(who, x) {
  if (x) console.log(who)
  console.log(JSON.stringify(x || who))
  return x || who
}

// stolen from http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
export function printMoney(x, includeCents = true, includeDots = true) {
  const parts = Number.parseFloat(x || "0").toFixed(includeCents ? 2 : 0).split(".");
  if (includeDots) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function clextend(a, b) {
  return _.extend(_.clone(a), b)
}

/* array of keys, maps each key through k2v to create the value
 * ["lol", "omg"] => { lol: true, omg: true }
 * dictWithKeys is just an alias */
export function mapToObject(ks, k2v = (k => true)) {
  const o = {}
  ks.forEach(k => { o[k] = k2v(k) })
  return o
}
export function dictWithKeys(ks, k2v = () => true) {
  return mapToObject(ks, k2v)
}

export function beep() {
  const snd = new Audio("data:audio/wav;base64,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")
  snd.play()
}

export function swap<T>(array: T[], a: number, b: number): T[] {
  return array.map((x, i) => {
    if (i === a) return array[b]
    if (i === b) return array[a]
    return x
  })
}

// reductors
export function flattenReductor(accum = [], element) {
  return accum.concat(element)
}

/* Note on `includeTake`
 * for some transportation means, the connector (preposition? verb? idk) 搭乘 is
 * redundant or doesnt make sense. */

/**
 * insert in a particular position of an array
 */
export function insertAt(a, i, x, { spread } = { spread: false }) {
  return spread && isArray(x)
    ? [...a.slice(0, i), ...x, ...a.slice(i)]
    : [...a.slice(0, i),    x, ...a.slice(i)]
}

/**
 * move an element from one position to another
 * if position is outside the array, the array grows with undefineds
 */

function moveInArray(array, origin, destination) {
  if (destination >= array.length) {
    let k = destination - array.length;
    while ((k--) + 1) { array.push(undefined); }
  }
  array.splice(destination, 0, array.splice(origin, 1)[0]);
  return array; // for testing purposes

}


/**
 * move an element inside an array
 * "El que estaba en la posición `from` ahora va a estar en `to`"
 */
export function moveInArray<T>(a: T[], from: number, to: number): T[] {
  if (from === to) return a
  const withoutIt = a.filter((x, i) => i !== from)
  return insertAt(withoutIt, to, a[from])
}


export function round(x, to, onlyUp) {
  if (!x) return 0
  else if (!to) return x
  else if (onlyUp) return to * Math.ceil(x / to);

  return to * Math.round(x / to);
}

export function partitionOn(array, isSeparator) {
  const partitions = [[]]
  let currentPartition = 0

  array.forEach((x, i) => {
    if (isSeparator(x, i)) {
      partitions.push([])
      currentPartition += 1
    }
    else {
      partitions[currentPartition].push(x)
    }
  })

  return partitions.filter(x => x.length > 0)
}

/**
 * partitions an array in a kinda-fair way, from a max partition size
 * the remainder is equally divided, giving priority to the first elements.
 */
export function partitionFairly(array, maxSize) {    // array.length = 21, maxSize = 13
  if (maxSize === 0) { return [array]; }

  const n = array.length                             // n = 21
  const numPartitions = Math.ceil(n / maxSize)       // numPartitions = ⌊21/13⌋+1 = 2
  const baseSize = Math.floor(n / numPartitions)     // baseSize = ⌊21/2⌋ = 10
  const remain = n - (numPartitions * baseSize)      // remain = 21 - 10*2 = 1

  const sizes = Array(numPartitions).fill(baseSize)

  let r = remain
  let i = 0
  while (r) {
    sizes[i++] += 1
    --r
  }

  const partitions = []
  let idx = 0
  for (let j = 0; j < numPartitions; ++j) {
    const partition = array.slice(idx, idx + sizes[j])
    partitions.push(partition)
    idx += sizes[j]
  }

  return partitions
}

/**
 *
 */
export function partitionWithSize<T>(array: T[], size: number): Array<T[]> {
  if (!array.length) return []
  if (size === 0) return [[...array]]

  return array.reduce((result, next) => {
    const r = (last(result).length >= size
      ? [...result, []]
      : [...result])

    last(r).push(next);
    return r
  }, [[]])
}

/**
 * returns a function that is a negation of the given one
 */
export function not(foo: any): Function {
  if (isFunction(foo)) {
    return function notFun(...args) {
      return !foo(...args)
    }
  }

  return !foo
}

/**
 *
 */
export function getFileExtension(filename) {
  const pieces = filename.split(".");
  if (pieces.length < 2) return null;
  return last(pieces)
}

/**
 * IndexBy
 */
export function indexBy(col, by, sortComparison) {
  const r = {}

  col.forEach(item => {
    const k = isString(by) ? item[by] : by(item)
    if (!(r[k])) r[k] = []
    r[k].push(item)
  })

  if (!sortComparison) return r

  const rr = {}
  keys(r).forEach(k => {
    rr[k] = r[k].sort(sortComparison)
  })

  return rr
}

export function randstr(length = 6, opts) {
  opts = opts || {}
  return chance.string({
    length,
    pool: opts.justNumbers ? "0123456789" : "0123456789qwertyuiopasdfghjklzxcvbnm"
  })
}

export function randfloat(min, max) {
  return chance.floating({min, max})
}

export function randint(min, max) {
  return chance.integer({min, max})
}

/**
 *
 */

function _findNth<T>(array: T[], n: number, predicate: (T, number) => boolean): ?{ item: T, index: number } {
  let count = 0
  for (let i = 0; i < array.length; ++i) {
    if (predicate(array[i], i)) {
      ++count
      if (count == n) return { item: array[i], index: i }
    }
  }
  return null
}

export function findNth<T>(array: T[], n: number, predicate: (T, number) => boolean): ?T {
  const r = _findNth(array, n, predicate)
  return r ? r.item : null
}

export function findNthIndex<T>(array: T[], n: number, predicate: (T, number) => boolean): ?number {
  const r = _findNth(array, n, predicate)
  return r ? r.index : null
}

/**
 * groupCountBy
 */

// like a groupBy, but only with the counts
// kinda naive and inefficient
export function groupCountBy(collection, iteratee) {
  const groups = _.groupBy(collection, iteratee)
  const counts = _.mapValues(groups, x => x.length)
  return counts
}

/**
 * Bulk operations
 */

export class OperationsBuffer {
  constructor(operation: (Array<any> => void), { maxInterval }: { maxInterval: number }) {
    this.maxInterval = maxInterval || 20 // seconds
    this.operation = operation

    this.buffer = []

    // #TODO: any way to dispose this on destruction?
    this.intervalHandle = setInterval(() => {
      operation(this.buffer)
      this.buffer = []
    }, this.maxInterval * 1000)
  }

  push(item: any) {
    this.buffer.push(item)
  }
}

/**
 *
 */

export const stringMax = array => {
  if (array.length == 0) return null

  let winner = array[0]

  array.forEach(item => {
    if (item > winner) winner = item
  })

  return winner
}

export const maxByKey = (array, key = identity) => {
  if (array.length == 0) return null

  let winner = array[0]
  let winnerK = key(winner)

  array.forEach(item => {
    if (key(item) > winnerK) {
      winner = item
      winnerK = key(item)
    }
  })

  return winner
}

export const isEqualOnKeys = (keys, a, b) => (
  _.every(
    (_.isArray(keys) ? keys : [keys]),
    key => a[key] === b[key]
  )
)

// from https://stackoverflow.com/q/684575
export function emptyOut(obj) {
  Object.keys(obj).forEach(k => {
    if (obj.hasOwnProperty(k)) {
      delete obj[k]
    }
  })
}

// Enumeraciones con conjunción

// [a, b, c, d] => a, b, c y d
export function enumerateSpanish(array) {
  if (array.length >= 2) {
    const first = array.slice(0, (array.length - 1)).join(", ")
    const lastElement = array[array.length - 1]
    return [ first, lastElement ].join(" y ")
  }
  else return array.join()
  // Nota: aunque el array tendrá 0 o 1 elementos, el join convierte a string 
  // justo como queremos, incluyendo undefineds, null... (ver spec)
}
